<template>
  <!-- <div class="container"> -->
  <!-- <div class="title">市场详情</div> -->
  <div class="mapbox">
    <div class="bg-image">
      <div class="map-charts" ref="chartDOM"></div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'MarketDetail',

  data() {
    return {
      marketData: [
        { name: '黄梅城东集货中心', toFactory: 128, toMarket: 46 },
        { name: '小池镇水产集货中心', toFactory: 96, toMarket: 38 },
        { name: '濯港镇冷链集货点', toFactory: 74, toMarket: 29 },
        { name: '蔡山镇水产交易中心', toFactory: 83, toMarket: 34 },
        { name: '大河镇冷链中转站', toFactory: 67, toMarket: 21 },
        { name: '独山镇水产集货点', toFactory: 52, toMarket: 18 },
        { name: '孔垄镇水产供应站', toFactory: 61, toMarket: 23 },
        { name: '五祖镇水产集散中心', toFactory: 45, toMarket: 16 },
        { name: '新开镇水产中转点', toFactory: 39, toMarket: 14 },
        { name: '龙感湖水产集货港', toFactory: 112, toMarket: 51 },
        { name: '黄梅城西集货中心', toFactory: 108, toMarket: 89 }
      ]
    }
  },

  mounted() {
    this.initMarketChart()
  },

  computed: {
    marketTotalData() {
      return this.marketData.map(item => ({
        marketName: item.name,
        totalBuy: item.toFactory + item.toMarket
      }))
    }
  },

  methods: {
    initMarketChart() {
      if (!this.marketData || this.marketData.length == 0) return

      const myChart = echarts.init(this.$refs['chartDOM'])

      window.addEventListener('resize', () => {
        myChart.resize()
      })

      const top_10Data = this.marketTotalData.sort((a, b) => b.totalBuy - a.totalBuy).slice(0, 10)
      const xData = top_10Data.map(item => item.marketName)
      const yData = top_10Data.map(item => item.totalBuy)

      const option = {
        title: {
          text: '集货点收虾数量TOP10',
          left: 'center',
          textStyle: {
            color: '#ffffff',
            fontSize: 18,
            fontWeight: 'bold'
          }
        },

        grid: {
          left: '5%',
          right: '5%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },

        xAxis: {
          type: 'category',
          data: xData,
          axisLine: {
            lineStyle: { color: '#1a4a6e' },
            symbol: ['none', 'arrow'], // [起点, 终点] 箭头
            symbolSize: [8, 12], // [宽, 高]
            symbolOffset: [0, 10] // 箭头偏移量
          },
          axisLabel: {
            color: '#8ecfff',
            fontSize: 12,
            interval: 0,
            rotate: 30 // 旋转角度
          },

          axisTick: { show: false }
        },

        yAxis: {
          type: 'value',
          name: '小龙虾收购量（吨）',
          nameTextStyle: {
            color: '#8ecfff',
            fontSize: 12
          },
          axisLabel: {
            color: '#8ecfff'
          },
          axisLine: {
            show: true,
            lineStyle: { color: '#1a4a6e' },
            symbol: ['none', 'arrow'], // [起点, 终点] 箭头
            symbolSize: [8, 12], // [宽, 高]
            symbolOffset: [0, 10] // 箭头偏移量
          },
          axisTick: { show: false },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.08)',
              type: 'dashed'
            }
          }
        },

        series: [
          {
            type: 'bar',
            data: yData, // 只显示前10名
            barWidth: '40%',
            // 柱子顶部数值标签
            label: {
              show: true,
              position: 'top',
              color: '#7ddfff',
              fontSize: 12,
              formatter: '{c}'
            },
            itemStyle: {
              //  渐变，从下到上
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: '#00c8ff' }, // 底部：青蓝色
                { offset: 1, color: '#c8f53c' } // 顶部：黄绿色
              ]),
              borderRadius: [16, 16, 0, 0] // 顶部圆角
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 0, color: '#00e0ff' },
                  { offset: 1, color: '#deff55' }
                ])
              }
            }
          }
        ]
      }

      myChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  /* 核心：确保每个组件都继承父级分配的高度 */
  /* height: calc(100% - 12px); */
  /* background: url('../images/bg_block.png') no-repeat; */
  height: 100%;

  position: relative;
  margin-bottom: 12px;
  z-index: 10;
  display: flex;
  flex-direction: column; /* 内部内容也纵向排列 */
}

.mapbox {
  height: 100%;
  padding: 16px;
}

.bg-image {
  width: 100%;
  height: 100%;
  /* background: url('../assets/images/map_bg.png') no-repeat center center;
  background-size: cover;
  border-radius: 12px; */
}

.map-charts {
  height: 100%;
  width: 100%;
}
</style>
